import { request } from 'utils/request';

type GiftCodeDiscountResponse = {};

export const requestGiftCodeDiscount = (code: string) => {
  return request.get<GiftCodeDiscountResponse>(
    `/api/internal/gift_code_discounts/${code}`,
  );
};

export const requestGiftCodeDiscountClaim = (code: string) => {
  return request.post<GiftCodeDiscountResponse>(
    `/api/internal/gift_code_discounts/${code}/claim`,
  );
};
